import { render, staticRenderFns } from "./pageElementCodefield.vue?vue&type=template&id=6ff5a136&scoped=true&"
import script from "./pageElementCodefield.vue?vue&type=script&lang=js&"
export * from "./pageElementCodefield.vue?vue&type=script&lang=js&"
import style0 from "./pageElementCodefield.vue?vue&type=style&index=0&id=6ff5a136&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff5a136",
  null
  
)

export default component.exports